import {
  RECEIVE_FACTRIB_PERIODS,
  RECEIVE_FACTRIB_TYPES,
  REQUEST_FACTRIB_PERIODS,
  REQUEST_FACTRIB_TYPES,
  SET_DEFINITION,
  SET_DEFINITIONS,
  REQUEST_DATA,
  RECEIVE_DATA,
  REQUEST_ALT_DATE_DATA,
  RECEIVE_ALT_DATE_DATA,
} from "./actions";
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import SelectionState from "state/selections/SelectionState";
import produce from "immer";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";
import { SummaryType } from "@ls/grouping-service";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  data: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  fetchingAltDateData: {
    [SummaryType.ABSOLUTE]: {},
    [SummaryType.RELATIVE]: {},
  },
  altDateData: {
    [SummaryType.ABSOLUTE]: {},
    [SummaryType.RELATIVE]: {},
  },
  fetchingFactribTypes: false,
  factribTypes: [],
  fetchingFactribPeriods: false,
  factribPeriods: [],
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      return setDefinitionToState(state, action.idx, action.definition);
    }
    case DELETE_COLUMN: {
      return removeDefinitionFromState(state, action.payload);
    }
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }

    case COMMIT_SELECTIONS:
      state.data = defaultState.data;
      state.altDateData = defaultState.altDateData;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;

    case REQUEST_DATA:
      state.fetchingData[action.payload.summary] = true;
      state.data[action.payload.summary] =
        defaultState.data[action.payload.summary];
      break;
    case RECEIVE_DATA:
      state.fetchingData[action.payload.summary] = false;
      state.data[action.payload.summary] = action.payload.data;
      break;
    case REQUEST_ALT_DATE_DATA:
      state.fetchingAltDateData[action.payload.summary][
        action.payload.asOfDate
      ] = true;
      state.altDateData[action.payload.summary] = {};
      state.altDateData[action.payload.summary][action.payload.asOfDate] = null;
      break;
    case RECEIVE_ALT_DATE_DATA:
      state.fetchingAltDateData[action.payload.summary][
        action.payload.asOfDate
      ] = false;
      state.altDateData[action.payload.summary][action.payload.asOfDate] =
        action.payload.data;
      break;
    case REQUEST_FACTRIB_TYPES:
      state.fetchingFactribTypes = true;
      state.factribTypes = defaultState.factribTypes;
      break;
    case RECEIVE_FACTRIB_TYPES:
      state.fetchingFactribTypes = false;
      state.factribTypes = action.payload.data;
      break;
    case REQUEST_FACTRIB_PERIODS:
      state.fetchingFactribPeriods = true;
      state.factribPeriods = defaultState.factribPeriods;
      break;
    case RECEIVE_FACTRIB_PERIODS:
      state.fetchingFactribPeriods = false;
      state.factribPeriods = action.payload.data;
      break;
    default:
      return state;
  }
});
export default reducer;
